import { render } from "./ProjectDataStep2.vue?vue&type=template&id=1ab79ee5"
import script from "./ProjectDataStep2.vue?vue&type=script&lang=js"
export * from "./ProjectDataStep2.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__